import React from 'react'
import { Box, Typography } from '@mui/material'
import { WatchLater } from '@mui/icons-material'
import theme from '../../theme'

interface Props {
  assetDuration: number
}

const CreativeClockIcon = ({ assetDuration }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.space['8'],
        padding: theme.space['8'],
        color: theme.palette['sage-400'],
        backgroundColor: theme.palette['sage-50'],
        height: '24px',
        borderRadius: theme.borders['rounded-8']
      }}
    >
      <WatchLater
        sx={{
          color: 'inherit',
          fontSize: '12px'
        }}
      />
      <Typography variant="ui-2" color={theme.palette['sage-900']}>
        {assetDuration ? `${Math.round(assetDuration)}s` : '-'}
      </Typography>
    </Box>
  )
}

export default CreativeClockIcon
